import { createStore } from "vuex";

import accounts from "./modules/accounts";
import auth from "./modules/auth";
import categories from "./modules/categories";
import common from "./modules/common";
import surveys from "./modules/surveys";
import products from "./modules/products";
import templates from "./modules/templates";
import validations from "./modules/validations";
import dashboard from "./modules/dashboard";
import navigation from "./modules/navigation";

export default createStore({
  modules: {
    accounts,
    auth,
    categories,
    common,
    surveys,
    products,
    templates,
    validations,
    dashboard,
    navigation,
  },
});
